const MIN_YEAR = 1800;

/*
 * get today's date with the format `YYYY-MM-DD`
 */
export const getTodayDateString = (): string => // TODO: use a proper date formatter
    new Date().toISOString().split('T')[0];

export const checkIfDateIsValid = (
    year: number,
    month: number,
    day: number,
): boolean => {
    const parsedDate = new Date(year, month - 1, day);

    // Check if the date is valid and components match the input
    return (
        parsedDate.getFullYear() === year &&
        parsedDate.getMonth() === month - 1 &&
        parsedDate.getDate() === day &&
        year > MIN_YEAR &&
        year.toString().length === 4
    );
};
